import React, { useState, useEffect } from "react";

const Navbar = () => {
  const [navBackground, setNavBackground] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false); // État pour le menu mobile
  const [showServices, setShowServices] = useState(false); // État pour le collapsible des services

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setNavBackground(true);
    } else {
      setNavBackground(false);
    }
  };

  return (
    <nav
      style={{ position: "fixed", zIndex: 9 }}
      className={`fixed top-0 left-0 right-0 z-9999 p-4 transition-colors duration-300 ${
        navBackground
          ? "bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-opacity-90 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div
        className="mx-auto flex justify-between items-center"
        style={{ width: "90%" }}
      >
        <a href="/" className="flex items-center">
          <img
            src="/images/logo_webminds.png"
            alt="WebMinds Logo"
            className="w-12 h-12 mr-2"
          />
          <div className="text-3xl font-bold text-white tracking-wide hidden sm:block">
            WebMinds
          </div>
        </a>
        <ul className="hidden md:flex space-x-8 relative text-white font-medium">
          <li onMouseEnter={() => setShowDropdown(false)}>
            <a
              href="/"
              className="hover:text-yellow-400 transition-colors duration-200"
            >
              Accueil
            </a>
          </li>
          <li
            className="relative flex items-center"
            onMouseEnter={() => setShowDropdown(true)}
          >
            <div className="flex items-center space-x-2 cursor-pointer">
              <div
                aria-disabled
                onClick={() => setShowDropdown(true)}
                className="hover:text-yellow-400 transition-colors duration-700"
              >
                Services
              </div>
              <i className="fas fa-chevron-down fa-1x"></i>
            </div>
          </li>
          <li onMouseEnter={() => setShowDropdown(false)}>
            <a
              href="/a-propos-de-nous"
              className="hover:text-yellow-400 transition-colors duration-200"
            >
              À propos
            </a>
          </li>
          <li>
            <a
              href="/contact"
              className="hover:text-yellow-400 transition-colors duration-200"
            >
              Contact
            </a>
          </li>
        </ul>

        <div className="md:hidden flex items-center">
          <button
            className="text-white focus:outline-none"
            onClick={() => setShowMenu(!showMenu)}
          >
            <i
              className={`fas ${showMenu ? "fa-times" : "fa-bars"} text-2xl`}
            ></i>
          </button>
        </div>
      </div>

      {showDropdown && (
        <div
          onMouseLeave={() => setShowDropdown(false)}
          className={`absolute top-full mt-1 bg-gray-900 rounded-md text-white shadow-lg z-10 p-8 grid grid-cols-1 md:grid-cols-3 gap-8 md:max-h-none md:overflow-visible 
                transition-transform duration-300 ease-out transform 
                ${
                  showDropdown
                    ? "animate-slideDownFadeIn"
                    : "animate-slideUpFadeOut"
                }`}
          style={{
            width: "90%",
            left: "5%",
            transform: "translateX(-50%)",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          {/* Section 1: Nos Offres Principales */}
          <div className="col-span-1">
            <h3 className="text-2xl font-semibold mb-4">
              Nos Offres Principales
            </h3>
            <div className="space-y-4">
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/vitrine.png"
                  alt="Site vitrine"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a href="/site-vitrine">
                    <h4 className="text-xl font-semibold mb-2 text-yellow-400">
                      Site vitrine et institutionnel
                    </h4>
                    <p className="text-sm text-gray-300">
                      Création de sites vitrines et institutionnels pour mettre
                      en avant votre entreprise.
                    </p>
                  </a>
                </div>
              </div>
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/ecommerce.png"
                  alt="Site E-Commerce"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a href="/site-e-commerce">
                    <h4 className="text-xl font-semibold mb-2 text-yellow-400">
                      Site E-Commerce
                    </h4>
                    <p className="text-sm text-gray-300">
                      Développement de sites e-commerce pour booster vos ventes
                      en ligne.
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Autres Services */}
          <div className="col-span-2">
            <h3 className="text-2xl font-semibold mb-4">Autres Services</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/seo.png"
                  alt="Référencement SEO"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a
                    href="/seo"
                    className="text-lg font-medium text-yellow-400 hover:text-white transition-colors duration-300"
                  >
                    Référencement SEO
                  </a>
                  <p className="text-sm text-gray-300">
                    Optimisation de votre site pour améliorer son
                    positionnement.
                  </p>
                </div>
              </div>
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/app.png"
                  alt="Application iOS / Android"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a
                    href="/application-mobile"
                    className="text-lg font-medium text-yellow-400 hover:text-white transition-colors duration-300"
                  >
                    Application iOS / Android
                  </a>
                  <p className="text-sm text-gray-300">
                    Développement sur mesure d'applications mobiles pour iOS et
                    Android.
                  </p>
                </div>
              </div>
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/social.png"
                  alt="Réseaux sociaux"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a
                    href="/reseau-sociaux"
                    className="text-lg font-medium text-yellow-400 hover:text-white transition-colors duration-300"
                  >
                    Réseaux sociaux
                  </a>
                  <p className="text-sm text-gray-300">
                    Gestion et optimisation de vos réseaux sociaux pour
                    renforcer votre visibilité.
                  </p>
                </div>
              </div>
              <div className="bg-gray-800 rounded-lg shadow-lg p-4 flex items-center hover:bg-gray-700 transition-colors duration-300">
                <img
                  src="/images/creative.png"
                  alt="Conception Graphique"
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="ml-4">
                  <a
                    href="/conception-graphique"
                    className="text-lg font-medium text-yellow-400 hover:text-white transition-colors duration-300"
                  >
                    Conception Graphique
                  </a>
                  <p className="text-sm text-gray-300">
                    Création de designs professionnels pour vos supports
                    marketing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Menu en plein écran pour mobile */}
      {showMenu && (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 z-50 p-6 transition-all duration-300">
          {/* Bouton pour fermer le menu */}
          <button
            className="absolute top-4 right-4 text-3xl text-yellow-400 hover:text-yellow-300 transition-colors duration-200 focus:outline-none"
            onClick={() => setShowMenu(false)}
            aria-label="Fermer le menu"
          >
            <i className="fas fa-times"></i>
          </button>

          {/* Titre du menu */}
          <h2 className="text-4xl font-bold text-center text-white mb-8">
            Menu
          </h2>

          {/* Conteneur des liens avec une carte pour chaque section */}
          <div className="flex flex-col space-y-4">
            {/* Section Services */}
            <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
              <button
                className="flex justify-between items-center w-full text-2xl font-semibold text-white hover:text-yellow-400 transition-colors duration-200"
                onClick={() => setShowServices(!showServices)}
              >
                Services
                <i
                  className={`fas ${
                    showServices ? "fa-chevron-up" : "fa-chevron-down"
                  }`}
                ></i>
              </button>
              {showServices && (
                <div className="mt-2 bg-gray-700 rounded-lg p-4">
                  <ul className="space-y-2">
                    <li>
                      <a
                        href="/site-vitrine"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Site vitrine
                      </a>
                    </li>
                    <li>
                      <a
                        href="/site-e-commerce"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Site E-Commerce
                      </a>
                    </li>
                    <li>
                      <a
                        href="/seo"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Référencement SEO
                      </a>
                    </li>
                    <li>
                      <a
                        href="/application-mobile"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Application Ios / Android
                      </a>
                    </li>
                    <li>
                      <a
                        href="/reseau-sociaux"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Réseaux sociaux
                      </a>
                    </li>
                    <li>
                      <a
                        href="/conception-graphique"
                        className="block text-lg text-white hover:text-yellow-400 transition-colors duration-200"
                        onClick={() => setShowMenu(false)}
                      >
                        Conception Graphique
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Autres liens */}
            <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
              <a
                href="/a-propos-de-nous"
                className="block text-2xl font-semibold text-white hover:text-yellow-400 transition-colors duration-200"
                onClick={() => setShowMenu(false)}
              >
                À propos
              </a>
            </div>

            <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
              <a
                href="/contact"
                className="block text-2xl font-semibold text-white hover:text-yellow-400 transition-colors duration-200"
                onClick={() => setShowMenu(false)}
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
